/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { formatEventDateTime } from '../../../utilities';
import { mapEventNameToText } from '../../../utilities/map-event-name-to-text';
import { DeliveryEventListProps } from '../lxs-anonymous-delivery.data';

const DeliveryEventList: React.FC<DeliveryEventListProps> = ({ CLASS_NAME, events, resources, localizationState }) => (
    <ul className={`${CLASS_NAME}-event-list`}>
        {events.map((event, index) => {
            const { formattedDate, formattedTime, offset } = formatEventDateTime(event.timestamp, localizationState);

            return (
                <li key={`${event.stepKey}-${event.timestamp}`} className={`${CLASS_NAME}-event-list-item completed`}>
                    <span className={`${CLASS_NAME}-event-list-bullet completed ${index === 0 ? 'checked' : ''}`} />
                    <span className={`${CLASS_NAME}-event-list-state`}>
                        <em>{mapEventNameToText(event.stepKey, resources)}</em>
                        {event.location && (
                            <>
                                {` ${resources.lxsAnonymousDeliveryEventLabelIn} `}
                                {event.location}
                            </>
                        )}
                        {` ${resources.lxsAnonymousDeliveryEventLabelOn} `}
                        {`${formattedDate} ${formattedTime} ${offset}`}
                    </span>
                </li>
            );
        })}
    </ul>
);

export default DeliveryEventList;
